import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import BotLinkWithCopy from "../../components/BotLinkWithCopy";

export function EditEpisode(props) {
    const { episode, onSaveClicked, onDeleteClicked } = props;
    const { register, handleSubmit, reset } = useForm({
        defaultValues: episode
    });

    const [isSaveHover, setIsSaveHover] = useState(false);
    const [isDelHover, setIsDelHover] = useState(false);

    useEffect(() => {
        reset(episode);
    }, [episode, reset]);

    const onSubmit = (data) => onSaveClicked(data);

    const inputStyle = {
        padding: '6px 8px',
        borderRadius: '6px',
        border: '1px solid #d1d5db',
        fontSize: '13px',
        outline: 'none',
        boxSizing: 'border-box'
    };

    const labelStyle = {
        fontSize: '11px',
        fontWeight: '700',
        color: '#6b7280',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    };

    return (
        <div style={{
            width: '100%',
            backgroundColor: '#f9fafb',
            padding: '8px 10px',
            borderRadius: '8px',
            marginBottom: '8px',
            border: '1px solid #e5e7eb',
            boxSizing: 'border-box'
        }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '6px'
            }}>
                {/* Рядок 1: Основні поля + Кнопки */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <input
                        {...register('serialOrder')}
                        type="number"
                        style={{ ...inputStyle, width: '45px', textAlign: 'center' }}
                    />

                    <input
                        {...register('name')}
                        type="text"
                        placeholder="Назва"
                        style={{ ...inputStyle, flex: '2' }}
                    />

                    <input
                        {...register('url')}
                        type="text"
                        placeholder="URL"
                        style={{ ...inputStyle, flex: '3' }}
                    />

                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexShrink: 0 }}>
                        <button
                            type="submit"
                            title="Зберегти"
                            onMouseEnter={() => setIsSaveHover(true)}
                            onMouseLeave={() => setIsSaveHover(false)}
                            style={{
                                backgroundColor: isSaveHover ? '#059669' : '#10b981',
                                color: 'white',
                                border: 'none',
                                width: '32px',
                                height: '32px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background-color 0.2s'
                            }}
                        >💾</button>

                        <button
                            type="button"
                            title="Видалити"
                            onMouseEnter={() => setIsDelHover(true)}
                            onMouseLeave={() => setIsDelHover(false)}
                            onClick={() => { if (window.confirm("Видалити?")) onDeleteClicked(episode) }}
                            style={{
                                backgroundColor: isDelHover ? '#dc2626' : '#ef4444',
                                color: 'white',
                                border: 'none',
                                width: '32px',
                                height: '32px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background-color 0.2s'
                            }}
                        >🗑️</button>

                        <BotLinkWithCopy externalId={episode.externalId}/>
                    </div>
                </div>

                {/* Рядок 2: Посилання UHD з лейблами */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingLeft: '51px', paddingRight: '104px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                        <span style={labelStyle}>UHD File:</span>
                        <input
                            {...register('uhdFileUrl')}
                            type="text"
                            placeholder="Не вказано"
                            style={{ ...inputStyle, flex: 1, backgroundColor: '#fff' }}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                        <span style={labelStyle}>UHD Video:</span>
                        <input
                            {...register('uhdVideoUrl')}
                            type="text"
                            placeholder="Не вказано"
                            style={{ ...inputStyle, flex: 1, backgroundColor: '#fff' }}
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}